export default __webpack_public_path__ + "media/color/cvc-45cc4bd5.svg";